export const mapIotPartnerToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfDevice: item?.devices?.length,
  }));

  return result;
};

export const iotPartnerColumns = [
  { key: "partnerName", label: "Name", align: "center" },
  { key: "numOfDevice", label: "Num Of Devices", align: "center" },
];
